import script from "./QuickActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuickActions.vue?vue&type=script&setup=true&lang=ts"

import "./QuickActions.vue?vue&type=style&index=0&id=75fb0d26&scoped=true&lang=css"

import exportComponent from "/home/dima/Work/pioneer-lk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75fb0d26"]])

export default __exports__